<div class="layout-content">
	<div *ngIf="editing" class="flex align-items-center justify-content-center w-full">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
	<form *ngIf="!editing" (ngSubmit)="submit()" [formGroup]="finalUserListForm">
		<div class="grid">
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.name, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME_LIST_FINAL_USERS' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.name, 'borderInput')">
						<input type="text" pInputText
							[ngClass]="dynamicInputTextWidth()"
							id="scenery-add-input-name"
							formControlName="name"
							autocomplete="scenery-name"
							placeholder="{{ 'NAME_LIST_FINAL_USERS' | translate }}"
							maxlength="26"
						/>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple
				label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mx-2"
				[ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()"
				label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mx-2"
				[ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>